import { render } from "./designSwitch.vue?vue&type=template&id=5f1eca9b&scoped=true"
import script from "./designSwitch.vue?vue&type=script&lang=js"
export * from "./designSwitch.vue?vue&type=script&lang=js"

import "./designSwitch.vue?vue&type=style&index=0&id=5f1eca9b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1eca9b"]])

export default __exports__